const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const numberFormatter = new Intl.NumberFormat("en-US");

const centsFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatCurrency(
  value: number | string | null | undefined,
): string {
  return currencyFormatter.format(Number(value ?? 0));
}

export function formatNumber(value: number): string {
  return numberFormatter.format(value);
}

export function formatCents(value: number | string): string {
  return centsFormatter.format(
    typeof value === "string" ? parseFloat(value) : value,
  );
}
